var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLecturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 650 650",
    style: {
      enableBackground: "new 0 0 650 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 195.9,
    r: 151.7
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.4,602.7 304.2,544.1 324.4,324.4 346.1,544.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.4,390.4l9.1-32c-18.2-9.7-34.6-22.3-48.6-37.1C128.7,363.9,90.1,433.4,90.1,512c0,11.6,0.9,23,2.5,34.1 c55.5,32.1,118.3,53,185.2,59.7L227.4,390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.1,321.2c-14,14.9-30.4,27.4-48.6,37.1l9.1,32l-50.4,215.5c67-6.7,129.7-27.7,185.2-59.7c1.6-11.1,2.5-22.5,2.5-34.1 C559.9,433.4,521.3,363.9,462.1,321.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecturer);
export default __webpack_public_path__ + "static/media/Lecturer.bbf1fcf4.svg";
export { ForwardRef as ReactComponent };